import { createFileRoute } from "@tanstack/react-router";
import { ErrorPage } from "../pages/ErrorPage";

// Search params type for the error route
export interface ErrorSearchParams {
  message?: string;
  attemptedRoute?: string;
  details?: string;
}

export const Route = createFileRoute("/error")({
  validateSearch: (search: Record<string, unknown>): ErrorSearchParams => ({
    message: search.message as string | undefined,
    attemptedRoute: search.attemptedRoute as string | undefined,
    details: search.details as string | undefined,
  }),
  component: ErrorPage,
});
